import React, { Component } from 'react'
import PropTypes from 'prop-types'
import WarningIcon from '@material-ui/icons/Warning'
import I18n from '../../../i18n/i18n'
import AppText from '../Texts/AppText'
import MainButton from '../Buttons/MainButton'
import GhostButton from '../Buttons/GhostButton'
import { Colors, Fonts, Images, Metrics } from '../../../Themes/'
import styles from '../../Styles/UI/Connections/UpgradeCard'
import stylesIcon from '../../Styles/UI/Connections/Card'

export default class ConnectionUpgradeCard extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    subscriptionsPlansAndPrices: PropTypes.array.isRequired,
    onPressItem: PropTypes.func.isRequired,
    isLast: PropTypes.bool,
    icon: PropTypes.string,
  }

  static defaultProps = {
    title: null,
    subscriptionsPlansAndPrices: null,
    onPressItem: null,
    isLast: false,
    icon: null,
  }

  renderIcon = () => {
    if (this.props.icon === 'miniV1V2') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    } else if (this.props.icon === 'twelveV') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    } else if (this.props.icon === 'mini') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    } else if (this.props.icon === 'pro') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    } else if (this.props.icon === 'proWithGyro') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    } else if (this.props.icon === 'miniV5Gyro') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    } else if (this.props.icon === 'gyro') {
      return (
        <img
          src={Images['list'][this.props.deviceOnline ? 'online' : 'offline'][this.props.icon]}
          style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
          alt="Device"
        />
      )
    }
    return (
      <img
        src={Images['list']['online'][this.props.icon]}
        style={{...stylesIcon.deviceImage, ...stylesIcon.deviceImageRemoveMarginLeft, objectFit: 'contain'}}
        alt="Device"
      />
    )
  }


  renderLineItem = (plan, index) => {
    // const { canEdit, left, right } = plan
    const { left, right } = plan
    const canEdit = false
    let lineItemStyles = [styles.lineItem]
    if ((index + 1) === this.props.subscriptionsPlansAndPrices.length) { lineItemStyles.push(styles.lineItemLast) }
    let buttonText = right !== I18n.t('shared.upgrade') ? I18n.t('shared.edit') : I18n.t('shared.upgrade')
    return (
      <div style={Object.assign({}, ...lineItemStyles)} key={'subscription-plan-' + index}>
        <div style={styles.lineItemLeft}>
          <AppText text={left} customStyle={styles.lineItemText} />
          {
            left !== I18n.t('shared.apiUser') && left !== I18n.t('shared.exhibitor') && right !== I18n.t('shared.upgrade') &&
            <AppText text={right} customStyle={styles.lineItemText} />
          }
        </div>
        <div style={styles.lineItemRight}>
          {
            canEdit && right === I18n.t('shared.upgrade') &&
            <MainButton
              key={'subscription-plan-' + index}
              buttonText={buttonText}
              onPress={() => { this.props.onPressItem(plan) }}
              disabled={false}
              icon={null}
              customButtonStyle={styles.lineItemButton}
              customTextStyle={styles.lineItemText}
            />
          }
          {
            canEdit && right !== I18n.t('shared.upgrade') &&
            <GhostButton
              key={'subscription-plan-' + index}
              buttonText={buttonText}
              onPress={() => { this.props.onPressItem(plan) }}
              disabled={false}
              icon={null}
              customButtonStyle={styles.lineItemButton}
              customTextStyle={styles.lineItemText}
            />
          }
          {
            (left === I18n.t('shared.apiUser') || left === I18n.t('shared.exhibitor')) &&
            <AppText
              text={right}
              customStyle={{
                ...styles.lineItemText,
                textAlign: 'right',
                fontWeight: Fonts.weight.bold,
                color: right === I18n.t('shared.paid') ? Colors.success : Colors.error
              }}
            />
          }
        </div>
      </div>
    )
  }

  renderContent = () => {
    return (
      <div style={{...styles.contentContainer, marginLeft: 0, marginTop: Metrics.baseMargin}}>
        {
          this.props.subscriptionsPlansAndPrices.map((s, i) => this.renderLineItem(s, i))
        }
      </div>
    )
  }

  render = () => {
    let containerStyle = {...styles.cardContainer}
    if (this.props.isLast) { containerStyle = {...containerStyle, marginBottom: 0} }
    return (
      <div style={containerStyle}>
        <div style={{...styles.card, ...(this.props.icon ? styles.cardRemovePaddingLeft : {})}}>
          { this.props.icon && this.renderIcon() }
          <div style={styles.contentContainer}>
            <div style={styles.contentContainerRow}>
              <AppText
                text={this.props.title}
                customStyle={{...styles.title, ...styles.titleFullWidth}}
                numberOfLines={1}
              />
              <div style={styles.iconWarningPayPending}>
                {this.props.unpaidSince && <WarningIcon style={{fontSize: 20, color: Colors.theme1}} /> }
              </div>
            </div>
            { this.renderContent() }
          </div>
        </div>
      </div>
    )
  }

}